import {
  Modal,
  Table,
  Progress,
  Statistic,
  Row,
  Col,
  Alert,
  Skeleton,
  Result,
  Button,
  Divider,
} from "antd";
import { useEffect, useReducer, useState } from "react";
import { createReceiver } from "@RECEIVERS";
import { exportExcel } from "@HELPERS";

const initialState = [];
const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_RECEIVERS":
      return payload.map((receiver) => ({
        ...receiver,
        status: "RUNNING",
      }));
    case "UPDATE_RECEIVER_STATUS_SUCCESS":
      return state.map((receiver) => {
        if (receiver.phone === payload.phone) {
          return {
            ...receiver,
            status: "SUCCESS",
          };
        }
        return receiver;
      });
    case "UPDATE_RECEIVER_STATUS_ERROR":
      return state.map((receiver) => {
        if (receiver.phone === payload.phone) {
          return {
            ...receiver,
            status: "ERROR",
            errorMessage: payload.errorMessage,
          };
        }
        return receiver;
      });
    default:
      break;
  }
};

const CreateResultModal = ({ onClose, data, onSuccessAndRemove, setStep }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [waitingCount, setWaitingCount] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allSuccess, setAllSuccess] = useState(false);
  const [allDone, setAllDone] = useState(false);
  const [errorList, setErrorList] = useState([]);

  const columns = [
    {
      title: "Telefon",
      dataIndex: "phone",
      key: "phone",
      width: "25%",
    },
    {
      title: "Durum",
      dataIndex: "status",
      key: "status",
      width: "50%",
      render: (data, record) => {
        switch (data) {
          case "RUNNING":
            return <Skeleton.Input active block shape="round" size="small" />;
          case "SUCCESS":
            return <Progress percent={100} size="small" />;
          case "ERROR":
            return (
              <Alert message={record.errorMessage} type="error" showIcon />
            );
          default:
            return "HATA!";
        }
      },
    },
  ];

  useEffect(() => {
    dispatch({ type: "SET_RECEIVERS", payload: data });
  }, [data, dispatch]);

  useEffect(() => {
    if (state) {
      const success = state?.filter(
        (receiver) => receiver.status === "SUCCESS"
      );
      const error = state?.filter((receiver) => receiver.status === "ERROR");
      const waiting = state?.filter(
        (receiver) => receiver.status === "RUNNING"
      );

      if (success.length === data.length) {
        setAllSuccess(true);
      }

      setSuccessCount(success.length);
      setErrorCount(error.length);
      setWaitingCount(waiting.length);
    }
  }, [data, state, dispatch]);

  useEffect(() => {
    if (allDone) {
      const doneReceivers = [];
      const errorReceivers = [];
      state.forEach((item, index) => {
        if (item.status === "SUCCESS") {
          doneReceivers.push(item.phone);
        } else {
          errorReceivers.push({
            firstName: item.firstName,
            lastName: item.lastName,
            phone: item.phone,
            city: item?.city?.name,
            town: item?.town?.name,
            district: item?.district?.name,
            addressLine: item.addressLine,
            errorMessage: item.errorMessage,
          });
        }
      });

      if (typeof onSuccessAndRemove === "function") {
        onSuccessAndRemove(doneReceivers);
      }

      if (errorReceivers.length > 0) {
        setErrorList(errorReceivers);
      }
    }
  }, [allDone, state]);

  const packageResolver = (item) => {
    let receiver = {
      firstName: item.firstName,
      lastName: item.lastName,
      phone: item.phone.replace(/ /g, ""),
      address: {
        city: item.city,
        town: item.town,
        district: item?.district ? item?.district : "",
        addressLine: item.addressLine,
      },
    };

    return new Promise((resolve) => {
      createReceiver(receiver).then((result) => {
        if (result?.response?.status === 400) {
          resolve({
            success: false,
            message: result.response.data.error.msg,
          });
        } else {
          resolve({ success: true });
        }
      });
    });
  };

  const packageDoNextPromise = (index) => {
    packageResolver(state[index]).then((result) => {
      if (result.success) {
        dispatch({
          type: "UPDATE_RECEIVER_STATUS_SUCCESS",
          payload: { phone: state[index].phone },
        });
      } else {
        dispatch({
          type: "UPDATE_RECEIVER_STATUS_ERROR",
          payload: {
            phone: state[index].phone,
            errorMessage: result.message,
          },
        });
      }
      index++;
      if (index < state.length) {
        packageDoNextPromise(index);
      } else {
        setLoading(false);
        setAllDone(true);
      }
    });
  };

  const downloadErrorReceivers = () => {
    exportExcel(
      "Hatalı Alıcı Bilgileri",
      [
        { title: "Ad", key: "firstName" },
        { title: "Soyad", key: "lastName" },
        { title: "Telefon Numarası", key: "phone" },
        { title: "İl", key: "city" },
        { title: "İlçe", key: "town" },
        { title: "Mahalle", key: "district" },
        { title: "Açık Adres", key: "addressLine" },
        { title: "Hata Sebebi", key: "errorMessage" },
      ],
      errorList
    );
  };

  useEffect(() => {
    if (state && state.length > 0 && !mounted) {
      packageDoNextPromise(0);
      setMounted(true);
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <Modal
      visible
      title="Toplu Alıcı Bilgisi Oluşturma Durumu"
      onCancel={() => {
        if (!loading) {
          onClose();
        }
      }}
      width={950}
      footer={null}
    >
      <Row gutter={24}>
        <Col span={8}>
          <Statistic
            title="Başarılı Alıcı Bilgisi Sayısı"
            value={successCount}
          />
        </Col>
        <Col span={8}>
          <Statistic title="Hatalı Alıcı Bilgisi Sayısı" value={errorCount} />
        </Col>
        <Col span={8}>
          <Statistic
            title="Sırada Bekleyen Alıcı Bilgisi Sayısı"
            value={waitingCount}
          />
        </Col>
      </Row>
      <div style={{ marginTop: 24 }}>
        {allSuccess ? (
          <>
            <Divider />
            <Result
              status="success"
              title="Alıcı Bilgileri Başarıyla Oluşturuldu"
              subTitle={`Alıcı Bilgileriniz başarıyla oluşturuldu.`}
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => setStep("TABLE")}
                >
                  Kayıtlı Alıcı Bilgilerim
                </Button>,
                <Button
                  key="buy"
                  onClick={() => {
                    onClose();
                  }}
                >
                  Kapat
                </Button>,
              ]}
            />
          </>
        ) : (
          <>
            <div style={{ textAlign: "right", marginBottom: 16 }}>
              <Button
                type="primary"
                danger
                onClick={() => downloadErrorReceivers()}
                disabled={!allDone || errorList.length === 0}
              >
                Hatalı Alıcı Bilgilerini İndir
              </Button>
            </div>
            <Table
              pagination={false}
              columns={columns}
              dataSource={state}
              scroll={{ y: 400 }}
              bordered
              rowKey="phone"
            />
          </>
        )}
      </div>
    </Modal>
  );
};

export default CreateResultModal;
